module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-map-panel gl-moving-history-log\" style=\"z-index: 10;\">\n	<div class=\"fixed-header-table\">\n		<table class=\"header\">\n			<col width=\"260\"/>\n			<col width=\"190\"/>\n			<col width=\"140\"/>\n			<col width=\"130\"/>\n			<tr>\n				<td>Время: сервер / трекер</td>\n				<td>Широта / Долгота</td>\n				<td>Пробег / Продол-ть</td>\n				<td>Курс / Скорость</td>\n				<td>ГЛОНАСС / GPS</td>\n			</tr>\n		</table>\n		<div name=\"container\" class=\"container\"></div>\n	</div>\n</div>\n\n<style>\n	.gl-moving-history-log {\n		position: absolute;\n		width: 860px;\n		background: rgba(0, 0, 0, 0.8);\n		overflow: hidden;\n	}\n\n	.gl-moving-history-log .container {\n		height: 400px;\n		overflow-y: scroll;\n	}\n\n	.gl-moving-history-log .highlight {\n		background: dimgrey;\n	}\n\n	.gl-moving-history-log .fixed-header-table .header, .gl-moving-history-log .fixed-header-table .content {\n		width: 100%;\n		word-wrap: break-word;\n	}\n\n	.gl-moving-history-log .fixed-header-table .header td {\n		padding: 3px 0;\n		font-weight: bold;\n	}\n</style>")
  }
  return __output.join("");

}